import React from "react";
import { inject, observer } from "mobx-react";
import { withRouter } from "react-router-dom";
import { Form } from "@op/opds.opux";
import { useMessageGetter } from "react-message-context";
import Info from "./Info";
import Login from "./Login";
import FeedbackHeader from "./FeedbackHeader";
import FeedbackType from "./fields/FeedbackType";
import FeedbackText from "./fields/FeedbackText";
import ContactCustomer from "./fields/ContactCustomer";
import ContactMethod from "./fields/ContactMethod";
import ContactDetailsWrapper from "./fields/ContactDetailsWrapper";
import ContactPhone, { ContactPhoneNoAnimation } from "./fields/ContactPhone";
import ContactEmail from "./fields/ContactEmail";
import ContactReachability from "./fields/ContactReachability";
import { BUSINESS, TUPAS, UNIDENTIFIED } from "../../utils/enums";
import CustomerName from "./fields/CustomerName";
import CustomerInfoWrapper from "./fields/CustomerInfoWrapper";
import FeedbackTarget from "./fields/FeedbackTarget";
import FeedbackSubject from "./fields/FeedbackSubject";
import Actions from "./Actions";
import FormError from "./FormError";
import ErrorSummary from "./ErrorSummary";
import ContinueSessionModal from "./ContinueSessionModal";
import DataDeletedModal from "./DataDeletedModal";

const Content = observer(({ RestStore, FeedbackStore, history }) => {
  const { customerType, customership, isSending, sendFeedback, showError } =
    RestStore;
  const {
    feedback,
    showContactDetails,
    contactByPhone,
    displayFeedbackSubject,
    isDirty,
    showErrorSummary,
    displayErrorSummary,
  } = FeedbackStore;
  const urlMsgs = useMessageGetter("url");
  const formMsgs = useMessageGetter("feedback.form");

  const handleSendFeedback = (callback) => {
    if (FeedbackStore.isInvalid) {
      displayErrorSummary(formMsgs);
      callback();
    } else {
      sendFeedback(feedback, callback, redirect);
    }
  };

  const redirect = (success) => {
    return history.push(urlMsgs(`${success ? "thanks" : "error"}`));
  };

  return (
    <>
      {showErrorSummary && <ErrorSummary />}
      <Info />
      <Login customerType={customerType} />
      <FeedbackHeader />
      <Form method="post" noValidate autoComplete="on">
        <FeedbackType />
        <FeedbackTarget />
        <FeedbackSubject mount={displayFeedbackSubject} />
        <FeedbackText
          popUpHintLabel={`feedback.sensitiveInfo.${
            customerType !== UNIDENTIFIED
              ? "identifiedCustomer"
              : "unidentifiedCustomer"
          }`}
          placeHolder={formMsgs("text.placeHolder")}
        />
        <ContactCustomer />
        <CustomerInfoWrapper
          mount={
            customerType === UNIDENTIFIED && feedback.contactCustomer.value
          }
        >
          <CustomerName />
        </CustomerInfoWrapper>
        <ContactMethod
          customerType={customerType}
          mount={feedback.contactCustomer.value}
        />
        <ContactDetailsWrapper mount={showContactDetails}>
          {[TUPAS, UNIDENTIFIED].includes(customerType) ? (
            <ContactPhoneNoAnimation />
          ) : (
            <ContactPhone mount={contactByPhone} />
          )}
          <ContactReachability
            mount={contactByPhone && customership === BUSINESS}
          />
          <ContactEmail />
        </ContactDetailsWrapper>
        {showError && <FormError mount={showError} />}
        <Actions
          isSending={isSending}
          isDirty={isDirty}
          handleSendFeedback={handleSendFeedback}
        />
      </Form>
      <ContinueSessionModal />
      <DataDeletedModal />
    </>
  );
});

export default withRouter(inject("RestStore", "FeedbackStore")(Content));
